// extracted by mini-css-extract-plugin
module.exports = {"side":"side_side__3fLCV"};